import groq from 'groq'
import { ButtonQuery } from '../atoms/ButtonQuery'

export const textContainerQuery = groq`
    _type == "textContainer" => {
      ...,
      alignment,
      innerBlocks[]{
        ...,
        _type == "button" => {
          ${ButtonQuery}
        },
      }
    }

`
